/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { GetOrdersQueryResponse, GetOrdersQueryParams, GetOrders400 } from '../entities/GetOrders'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getGetOrdersUrl() {
  return `/orders` as const
}

/**
 * @description Get orders
 * @summary Get orders
 * {@link /orders}
 */
export async function getOrders(params: GetOrdersQueryParams, config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<GetOrdersQueryResponse, ResponseErrorConfig<GetOrders400>, unknown>({
    method: 'GET',
    url: getGetOrdersUrl().toString(),
    params,
    ...requestConfig,
  })
  return res.data
}